<template>
  <div>
    <vue-custom-scrollbar class="scroll-area">
      <table class="table table-bordered table-sm">
        <thead class="bg-light">
          <tr>
            <th>Fees</th>
            <th>Amount</th>
            <th>Fine</th>
            <th>Discount</th>
            <th>Total</th>
            <th>Due</th>
            <th>Last Date</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody v-if="data.length">
          <tr v-for="fee in data" :key="fee.id">
            <th>{{ fee.fee_setting.class_fee ? fee.fee_setting.class_fee.fee.name : fee.fee_setting.fee.name }}</th>
            <td class="font-weight-bold">{{ fee.amount ? `₹ ${fee.amount}` : '₹ 0' }}</td>
            <td>{{ fee.fine ? `₹ ${fee.fine}` : '₹ 0' }}</td>
            <td>{{ fee.discount_amount ? `₹ ${fee.discount_amount}` : '₹ 0' }}</td>
            <td class="font-weight-bold">{{ fee.fee_total ? `₹ ${fee.fee_total}` : '₹ 0' }}</td>
            <td class="font-weight-bold">{{ fee.due_amount ? `₹ ${fee.due_amount}` : '₹ 0' }}</td>
            <td>{{ moment(fee.end_date).format(dateFormat) }}</td>
            <td class="font-weight-bold">{{ getPaymentStatus(fee.payment_status) }}</td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="4" class="pt-3">
              <a-tag color="orange">No fees found!</a-tag>
            </td>
          </tr>
        </tbody>
      </table>
    </vue-custom-scrollbar>
  </div>
</template>
<script>
import moment from 'moment'

import vueCustomScrollbar from 'vue-custom-scrollbar'

import { feeTypes } from '@/services/globaldata'
import { find } from 'lodash'

export default {

  name: 'FeeTable',
  components: {
    vueCustomScrollbar,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data: function() {
    return {
      feeTypes,
      dateFormat: 'DD-MM-YYYY',
    }
  },
  methods: {
    moment,
    find,
    getFeeType(type) {
      return find(this.feeTypes, { value: type }).name
    },
    getPaymentStatus(status) {
      if (status === 1) {
        return 'Paid'
      } else if (status === 0) {
        return 'Not Paid'
      } else {
        return 'Unknown'
      }
    },
  },
}
</script>
